module.exports = __webpack_public_path__ + "img/p3.f79bc579.png";